import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useColorMode } from '@chakra-ui/react';
import { theme } from '../../../modules/theme';
import { Typography } from '../../Typography';
export const AccentFolderCardTitle = forwardRef(({ variant, size, ...otherProps }, ref) => {
    const { colorMode } = useColorMode();
    return (_jsx(Typography, { ref: ref, variant: "display", size: { base: 'xs', md: 'sm', lg: 'sm' }, color: theme.colors[colorMode].text.primary, mb: { base: theme.sizes['4'], md: theme.sizes['6'], lg: theme.sizes['6'] }, ...otherProps }));
});
